package com.trevorwiebe.timesheet.punch.domain.usecases

import com.trevorwiebe.timesheet.core.domain.Util.localDateTime
import com.trevorwiebe.timesheet.core.domain.model.Organization
import com.trevorwiebe.timesheet.core.domain.usecases.GetCurrentPayPeriodStartAndEnd
import kotlinx.datetime.DateTimeUnit
import kotlinx.datetime.LocalDateTime
import kotlinx.datetime.atTime
import kotlinx.datetime.plus

class CalculateTimeSheets(
    private val getCurrentPayPeriodStartAndEnd: GetCurrentPayPeriodStartAndEnd
) {

    operator fun invoke(
        organization: Organization,
    ): List<LocalDateTime> {

        val currentDate = localDateTime().date
        val payPeriodStartDateTime = getCurrentPayPeriodStartAndEnd(organization).first

        return generateSequence(payPeriodStartDateTime) { it.date.plus(1, DateTimeUnit.DAY).atTime(0, 0) }
            .takeWhile { it.date <= currentDate }
            .toList()
            .sortedByDescending { it.date }
    }
}